import { render, staticRenderFns } from "./ReportingCard.vue?vue&type=template&id=31c92ed2&scoped=true"
import script from "./ReportingCard.vue?vue&type=script&lang=js"
export * from "./ReportingCard.vue?vue&type=script&lang=js"
import style0 from "./ReportingCard.vue?vue&type=style&index=0&id=31c92ed2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c92ed2",
  null
  
)

export default component.exports